import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import __ from 'lodash';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';


import { Grid, Typography, TextField, Button } from '@material-ui/core';
import LoaderModal from '../../../modal/LoaderModal';

class VerifikasiEmail extends Component {
    constructor(props){
        super(props);

        const search = this.props.location.search;
        
        this.state = {
            isFetching: true,
            response: {},
            idSekolah : new URLSearchParams(search).get("idSekolah"),
            token : new URLSearchParams(search).get("token")
        }
    }

    componentDidMount(){
        this.fetchMockupDetail();
        this.doVerificationEmail();
    }

    doVerificationEmail = async () =>{
        const {idSekolah, token} = this.state;

        const response = await accountManagement.put(CONFIG.ACCOUNT_MANAGEMENT_VERIFICATION_ACCOUNT 
                +'idSekolah='+ idSekolah
                +'&token='+ token 
            ).catch(function(error){
                console.info('Error Verifi', error)
        })
    }

        
    fetchMockupDetail = async () => {
        const axios = require('axios');
        const res = await axios.get('https://run.mocky.io/v3/fd7313f5-0fb0-4c14-ada4-61b1a7bacb71');
        this.setState({
            response: res.data.data,
            isFetching: false
        });
    }

    render() {
        const {isFetching, response} = this.state;
        return (
            <Container>
                <Grid
                    spacing={2}
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{textAlignLast: "center"}}
                    >
                        <Grid item xs={12}>
                            <LoaderModal isFetching={isFetching} />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h5" color="textPrimary">Verifikasi User Account PSEP</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            {
                                response.verifiedStatus === "verified" &&
                                    <Typography variant="body1" color="textPrimary">
                                        Selamat Username & Password anda telah aktif, silahkan melakukan login <a style={{color: "blue"}} href="https://psep.eduprime.co.id/login">disini..</a>
                                    </Typography>
                            }
                        </Grid>
                </Grid>
            </Container>
        );
    }
}

export default VerifikasiEmail;